import { useMemo } from "react";
import { createMuiTheme, useTheme } from "@material-ui/core";

/**
 * Custom hook for creating a MaterialTable theme with swapped primary/secondary colors
 * This allows the selection toolbar to use the primary color instead of secondary
 *
 * @returns {Object} MUI Theme object with swapped palette colors
 */
const useTableTheme = () => {
  const theme = useTheme();

  const tableTheme = useMemo(
    () =>
      createMuiTheme({
        ...theme,
        palette: {
          ...theme.palette,
          secondary: theme.palette.primary,
        },
      }),
    [theme]
  );

  return tableTheme;
};

export default useTableTheme;
